module.exports = __webpack_public_path__ + "img/open_square_icon.6956e3a5.svg";